/** @format */

// Kill switches for Preview and Production

import { KillSwitches } from '@shared/data-access/interfaces';

const killSwitchProd: KillSwitches = {
	// please keep in alpha order
	adeptMindScriptEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	alternativeInStockRecsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	alternativeInStockRecsExperienceBEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	boplExperienceEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	browseBreadcrumbsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	enhancedContentEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	certonaQuickviewEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	colorSelectionPanelEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	crossChainBopis: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	dataScienceRecommendationsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	dropdownAttributesEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	enableAEMContent: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	enableTooltipSurvey: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	favoritesEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	feedbackSurveyEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	floorModelMessageEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	frequentlyBoughtTogetherEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	honeycombEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	hybridPDPTemplate: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	infoSummaryEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	inStoreServicesEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isBrandLinkEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isComparisonTableEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isDescriptiveH2Enabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isEDDforLTLProductsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isEnhancedSalesPriceEnable: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isExceedsInventoryMsgEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isFBTFavoriteButtonEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isGoldExclusiveEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isImageGalleryZoomEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isJumpLinkEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isLoadingStateRecsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isNewRecsCardsNotifyMePanelEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isNewReviewsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isRecsDisplayedInATCPanelEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isReviewImgPlacementEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isSketchfab3dEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isSSRPLAEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isNikeConnectedEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isPLADSCarouselEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isPLAEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	// Spinner toggled to show right after SSR on PLA pages but that does not affect caching.
	isPLAPlaceholderEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isReviewsAISummaryEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isRibbonGAMBannerEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	isScorerewardsMessageEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isShoppableBVImageEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isUsingCriteoSPAAdServer: {
		dsg: true,
		gg: true,
		g3: false, //Criteo not available for g3
		pl: false //Criteo not available for pl
	},
	isSocialImagesEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	javaNestKickOver: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	listsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	nearbyStoresButtonEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		mj: false,
		g3: false
	},
	newEATApiEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	nonExclusiveContentZoneEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	notifyMeSCGoldMessageEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	notifyUserWhenAvailableEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	newDataScienceRecommendationsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	oosRecommendations: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	pdpGoogleAdManagerEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	pdpSkuEDDEventEnabled: {
		dsg: false,
		gg: true,
		pl: false,
		g3: false
	},
	isFrequentItemAccordionEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isPartyAttributesEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isUtahLawLabelAccordionEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	preOrderEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	preOrderMessagingImprovementsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	readyForNextRoundAddOnsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	registeredUsersEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	reviewsOff: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	reviewsSEOClient: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	reviewsSubmissionFormV2Enabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	reviewsMVPRetest: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	newReviews: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	reviewsFilters: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	reviewsHighlightsUpdateEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	reviewsProsCons: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	rightHandRailYouMayAlsoLikeEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	rightHandRailCustomersAlsoBoughtEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	sameDayDeliveryEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	ScoreCardData: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	sddUpdatedCutoffEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	serviceWorker: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	sizeSelectionPanelEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	showSponsoredProducts: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	skuEDDEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	skuEDDEnabledV1: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	styliticsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	styliticsShopTheLookEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	styliticsShopTheSetEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	sustainablityIconsEnabled: {
		dsg: false,
		gg: false,
		pl: true,
		g3: false
	},
	syndigoEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isPDPProTipsEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	truefitEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	useNewProductService: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	useNewPricingService: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	useProductCatalogRatingData: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	useQVProductService: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	useQVProductTemplate: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	styliticsMnMEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	trueFitExperimentsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	showNewReviewsQA: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	newDataScienceRecommendationsEnabledNoPer: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	triggerSponsoredProductsShownEvent: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	shortenPurchasePathUpdatesATCEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	shortenPurchasePathCheckoutButtonATCEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	useAboveTheFoldMobileContainer: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isHighlyRatedReviewsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	useCachedCeopsScripts: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	warrantiesEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	warrantiesSelectionOnAtcEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isSocialImageBelowProductInfoEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isSocialImageAboveReviewsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isUtagBazaarvoiceEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	}
};

export default killSwitchProd;
